import { render, staticRenderFns } from "./CustomPreventions.vue?vue&type=template&id=164b625e&"
import script from "./CustomPreventions.vue?vue&type=script&lang=js&"
export * from "./CustomPreventions.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {MapAddress: require('/Users/pam/Documents/Projects/cmp/cmp/city-manager-platform/components/Map/Address.vue').default})
